app.directive('compareInterest', ['$http', 'bezoeker', '$window', '$timeout', function($http, bezoeker, $window, $timeout){
    return {
        restrict: 'EAC',
        scope: {
          productvorm: '@?',
          titel: '@?'
        },
        templateUrl: '/templates/compare-interest.html',
        link: function($scope, $element) {

            $scope.bezoeker = bezoeker;
            $scope.productvorm = 'persoonlijke lening';
            $scope.looptijd = 72;

            $scope.bedrag = bezoeker.gewenstLeenbedrag;
            $scope.combinatieRentetarieven = false;

            $scope.maandlastOptions = [{label : '€ '+($scope.bedrag * 0.01).toFixed(2).replace('.',','), value: 0},{label : '€ '+($scope.bedrag * 0.015).toFixed(2).replace('.',','), value: 1},{label: '€ '+($scope.bedrag * 0.02).toFixed(2).replace('.',','), value: 2}];
            $scope.maandlast = $scope.maandlastOptions[0];

            $scope.$watch('bedrag', function(){
                $scope.maandlastOptions = [{label : '€ '+($scope.bedrag * 0.01).toFixed(2).replace('.',','), value: 0},{label : '€ '+($scope.bedrag * 0.015).toFixed(2).replace('.',','), value: 1},{label: '€ '+($scope.bedrag * 0.02).toFixed(2).replace('.',','), value: 2}];
                $scope.maandlast = $scope.maandlastOptions[$scope.maandlast.value];
            }, true);

            $scope.Math = $window.Math;

            $scope.getRentetarieven = function(){

                if($scope.bedrag < 5000) $scope.bedrag = 5000;

                $scope.bezoeker.gewenstLeenbedrag = $scope.bedrag;
                $scope.bezoeker.store();

                var numb = $scope.bedrag.toString().match(/\d/g);
                $scope.bedrag = numb.join("");

                $http.post('/rentetarieven/getInterestAllBanks/', {'bedrag' : $scope.bedrag, 'product' : $scope.productvorm, 'looptijd' : $scope.looptijd, 'maandlast' : $scope.maandlast.value}).

                    success(function(data, status, headers, config) {
                        // console.log(data);
                        $scope.rentetarieven = data;



                        // $timeout(function(){
                        //     $element.find('.stacktable.small-only').remove();
                        //     $element.find('#compare-interest table').stacktable();
                        // }, 500);

                    });

                if($scope.bedrag > 50000)
                {
                    $http.post('/rentetarieven/getInterestCombinationCredit/', {'bedrag' : $scope.bedrag, 'product' : $scope.productvorm, 'looptijd' : $scope.looptijd, 'maandlast' : $scope.maandlast.value}).

                    success(function(data, status, headers, config) {

                        $scope.combinatieRentetarieven = data;

                        // $timeout(function(){
                        //     $element.find('.stacktable.small-only').remove();
                        //     $element.find('#compare-interest table').stacktable();
                        // }, 500);

                    });
                }else{
                    $scope.combinatieRentetarieven = false;
                }

            };

            $scope.bankImages = {
                'defam' : '/uploads/images/banken/defam_2.png',
                'defam premium' : '/uploads/images/banken/defampremium.jpg',
                'Defam premium' : '/uploads/images/banken/defampremium.jpg',
                'ABN Amro' : '/uploads/images/banken/abnamro.jpg',
                'Santander' : '/uploads/images/banken/santander.gif',
                'MoneYou' : '/uploads/images/banken/moneyou.gif',
                'SNS Bank' : '/uploads/images/banken/snsbank.png',
                'Rabobank' : '/uploads/images/banken/rabobank.jpg',
                'ING' : '/uploads/images/banken/ing.jpg',
                'interbank' : '/uploads/images/banken/interbank2.png',
                'nn' : '/uploads/images/banken/nationalenederlanden.jpg',
                'Nationale Nederlanden' : '/uploads/images/banken/nationalenederlanden.jpg',
                'Sygma' : '/uploads/images/banken/qander.jpg',
                'Qander' : '/uploads/images/banken/qander.jpg',
                'Directa' : '/uploads/images/banken/directa.jpg',
                'Findio' : '/uploads/images/banken/findio.png',
                'Freo' : '/uploads/images/banken/freo.jpg'
            };

            $scope.getBankImage = function(bank)
            {

                if(typeof $scope.bankImages[bank] !== 'undefined')
                    return $scope.bankImages[bank];
                else
                    return false;
            };

            $scope.onSubmit = function($event)
            {
                $event.preventDefault();
                var looptijd = null;
                var maandlast = null;
                var maandtermijnIndex = null;

                console.log($scope.productvorm);

                if($scope.productvorm == 'persoonlijke lening')
                {
                  looptijd = $scope.looptijd;
                }else{
                  maandtermijnIndex = $scope.maandlast.value;
                }

                $http.post('/session/saveUser/', {'productvorm' : $scope.productvorm, 'leenbedrag' : $scope.bedrag, 'looptijd' : looptijd, 'maandtermijnIndex' : maandtermijnIndex}).success(function(data, status, headers, config) {
                    $window.location.href = '/offerte-aanvragen/';
                });
            };

            $scope.onSubmitCombinatie = function($event)
            {
                $event.preventDefault();
                var looptijd = null;
                var maandlast = null;
                var maandtermijnIndex = null;

                if($scope.productvorm == 'persoonlijke lening')
                {
                  looptijd = $scope.looptijd;
                }else{
                  maandtermijnIndex = $scope.maandlast.value;
                }

                $http.post('/session/saveUser/', {'productvorm' : $scope.productvorm, 'leenbedrag' : $scope.bedrag, 'looptijd' : looptijd, 'maandtermijnIndex' : maandtermijnIndex}).success(function(data, status, headers, config) {
                    $window.location.href = '/offerte-aanvragen/#?combinatie=true&productvorm='+$scope.productvorm;
                });
            };

            $scope.getRentetarieven();
        }
    };
}]);